// src/components/StripeRetour.jsx
// Page où Stripe renvoie le créateur après le formulaire.

import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getStatutStripe, demarrerOnboardingStripe } from "../services/StripeConnectService";

const PAGE_DEFAUT = "/EspaceClient/mabilletterie";

const StripeRetour = ({ mode = "retour" }) => {
    const navigate = useNavigate();
    const { search } = useLocation();

    // Corrige l'ancienne adresse "billetterie" → "mabilletterie"
    let retour = new URLSearchParams(search).get("retour") || PAGE_DEFAUT;
    if (!retour.startsWith("/EspaceClient") || retour === "/EspaceClient/billetterie") {
        retour = PAGE_DEFAUT;
    }

    const [message, setMessage] = useState("Vérification de votre compte…");

    useEffect(() => {
        (async () => {
            try {
                if (mode === "refresh") {
                    setMessage("Le lien a expiré, on vous redirige vers Stripe…");
                    await demarrerOnboardingStripe(retour);
                    return;
                }

                const s = await getStatutStripe();
                if (s.statut === "actif") {
                    setMessage("✅ Paiements activés ! Vous pouvez vendre des billets.");
                    toast.success("Paiements activés !");
                } else if (s.statut === "en_verification") {
                    setMessage("⏳ Informations envoyées, Stripe vérifie votre compte.");
                    toast.info("Stripe vérifie votre compte.");
                } else {
                    setMessage("⚠️ Configuration pas encore terminée.");
                    toast.warn("Configuration pas encore terminée.");
                }
            } catch (e) {
                setMessage("Erreur : " + e.message);
                toast.error(e.message);
            }

            // 2,5 s pour lire le message, puis retour à Ma Billetterie
            setTimeout(() => navigate(retour, { replace: true }), 2500);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode]);

    return (
        <div className="w-full min-h-[60vh] flex flex-col items-center justify-center gap-3 bg-white">
            <ToastContainer position="top-right" autoClose={3000} />
            <div className="w-10 h-10 border-4 border-violet-200 border-t-violet-600 rounded-full animate-spin" />
            <p className="text-sm text-gray-600 font-medium">{message}</p>
        </div>
    );
};

export default StripeRetour;